import {
  GET_HISTORY_REQUEST,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  INVALIDATE_TICKET_HISTORY
} from './historyTypes';

/**
 * Estado inicial del reducer de historial
 * @type {Object}
 * @property {Object} history - Objeto que mapea ticketId -> array de entradas de historial
 * @property {boolean} loading - Indica si hay una operación en curso
 * @property {null|string} error - Mensaje de error si existe
 */
const initialState = {
  history: {}, // Objeto que mapea ticketId -> array de entradas de historial
  loading: false,
  error: null
};

/**
 * Reducer para gestionar el estado del historial de tickets
 * Implementa el patrón de responsabilidad única manejando solo operaciones relacionadas con historial
 * 
 * @param {Object} state - Estado actual del reducer
 * @param {Object} action - Acción a procesar con type y payload
 * @returns {Object} Nuevo estado
 */
const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    // Casos para obtener historial
    case GET_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        history: {
          ...state.history,
          [action.payload.ticketId]: action.payload.history
        },
        loading: false
      };

    case GET_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    // Caso para invalidar (limpiar) el historial de un ticket
    case INVALIDATE_TICKET_HISTORY:
      const { ticketId } = action.payload;
      const newHistoryState = { ...state.history };
      delete newHistoryState[ticketId];
      return {
        ...state,
        history: newHistoryState
      };

    default:
      return state;
  }
};

export default historyReducer; 